import { render, staticRenderFns } from "./admin.clients.new.page.vue?vue&type=template&id=44ee041d&scoped=true&"
import script from "./admin.clients.new.page.vue?vue&type=script&lang=js&"
export * from "./admin.clients.new.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.clients.new.page.vue?vue&type=style&index=0&id=44ee041d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ee041d",
  null
  
)

export default component.exports